<template>
   <billing-Layout>
  <slot>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title">My Organizations</h4>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex align-items-right justify-content-end">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="'/setting'" class="btn btn-info btn-sm mr-2"><i class="fas fa-arrow-left"></i> Back</router-link>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
      
        <div class="container-fluid">
            <div class="row">
            <div class="col-12">

        <div class="card card-body">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col" style="width:5%;">ID</th>
                        <th scope="col" style="width:75%;">COMPANY NAME</th>
                        <th scope="col" style="width:10%; text-align:right">STATUS</th>
                        <th scope="col" style="width:10%;"><button class="btn btn-success btn-sm mr-2 float-right" @click="MetAddNewTaxBtn"><i class="fas fa-plus"></i> NEW</button></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="i in organizationslist" :key="i.id">
                        <td scope="row">{{i.id}}</td>
                        <td>{{i.bill_company_name}}</td>
                        <td><span class="activeorg" v-if="i.active == 1"></span><span class="offorg" v-else></span></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
           <!--  <Loader v-if="isloaing"></Loader> -->
            <div v-if="NoRecordTaxe ==true" class="text-center">SIN REGISTRO</div>

 
                </div>
              </div>
            </div>
        </div>
         <modal name="setting-org" height="auto">
         <div class="card-header">NEW ORGANIZACION</div>
            <div class="card-body">

            <form @submit.prevent="saveOrg"  enctype="multipart/form-data" id="form1">
          <div class="row">
            <div class="col-12">
              <div class="estilosform">               
                <div class="row">
                  <div class="col-md-3 text-right marginTop">
                    <label for="" class="col-form-label ">Name Organization</label>
                  </div>
                  <div class="col-md-9 marginTop">
                    <input type="text" class="form-control" id=""  v-model="FormCompanyInfo.companyname" required>
                  </div>
                  <div class="col-md-3 text-right marginTop">
                    <label for="" class="col-form-label">First Name</label>
                  </div>
                  <div class="col-md-9 marginTop">
                    <input type="text" class="form-control" v-model="FormCompanyInfo.firstname">
                  </div>
                  <div class="col-md-3 text-right marginTop">
                    <label for="" class="col-form-label">Last Name</label>
                  </div>
                  <div class="col-md-9 marginTop">
                    <input type="text" class="form-control" v-model="FormCompanyInfo.lastname">
                  </div>
                  <div class="col-md-3 text-right marginTop">
                    <label for="" class="col-form-label">Address</label>
                  </div>
                  <div class="col-md-9 marginTop">
                    <input type="text" class="form-control" v-model="FormCompanyInfo.address">
                  </div>
                  <div class="col-md-3 text-right marginTop">
                    <label for="" class="col-form-label">City</label>
                  </div>
                  <div class="col-md-9 marginTop">
                    <input type="text" class="form-control" v-model="FormCompanyInfo.city">
                  </div>
                  <div class="col-md-3 text-right marginTop">
                    <label for="" class="col-form-label">State</label>
                  </div>
                  <div class="col-md-9 marginTop">
                    <input type="text" class="form-control" v-model="FormCompanyInfo.state">
                  </div>
                  <div class="col-md-3 text-right marginTop">
                    <label for="" class="col-form-label">Zip Code</label>
                  </div>
                  <div class="col-md-9 marginTop">
                    <input type="text" class="form-control" v-model="FormCompanyInfo.zipcode">
                  </div>
                  <div class="col-md-3 text-right marginTop">
                    <label for="" class="col-form-label">Telephone</label>
                  </div>
                  <div class="col-md-9 marginTop">
                    <input type="text" class="form-control" v-model="FormCompanyInfo.telephone">
                  </div>
                  <div class="col-md-3 text-right marginTop">
                    <label for="" class="col-form-label">E-mail</label>
                  </div>
                  <div class="col-md-9 marginTop">
                    <input type="text" class="form-control" v-model="FormCompanyInfo.email">
                  </div>
                  <div class="col-md-3 text-right marginTop">
                    <label for="" class="col-form-label">Website</label>
                  </div>
                  <div class="col-md-9 marginTop">
                    <input type="text" class="form-control" v-model="FormCompanyInfo.website">
                  </div>
                  <div class="col-md-12">
                    <div style="margin-top:15px;display: flex;justify-content: flex-end;">
                      <button type="submit" class="btn btn-success " style="margin-right:10px;">SAVE</button>
                    </div>
                  </div>
                </div>              
              </div>
            </div>
           
          </div>
        </form>
<Loader v-if="isloaing"></Loader>
            </div>
        </modal>
    </slot>
    <notifications group="noti" position="top center"></notifications>
   </billing-Layout> 
</template>
<script>
import axios from 'axios'
import Loader from '@/components/shared/Loader'
import BillingLayout from '@/Layouts/Billing/BillingLayout'

export default {
  components:{
      BillingLayout,
      Loader
  },
  data() {
    return {
      isloaing : false,
      organizationslist :[],
      FormCompanyInfo : {
            title : null,
            action : null,
            companyname : null,
            firstname : null,
            lastname : null,
            address : null,
            city : null,
            state : null,
            zipcode : null,
            telephone : null,
            email : null,
            website : null,
      },
      NoRecordTaxe : false
    }
  },
   mounted(){
    this.getOrganizations();
    },
     methods:{
        getOrganizations() {
            this.isloaing = true
            window.billing.get(window.urlmaster +'api/organizationall/' + window.localuserdata)
                .then((response) => {
                    console.log(response.data)
                    this.organizationslist = response.data.result;
					this.isloaing = false
                }).catch((error) => console.log(error));
        },
        MetAddNewTaxBtn(){
            this.$modal.show('setting-org');
            this.FormCompanyInfo.title = 'ADD';
            this.FormCompanyInfo.action = 'add';
        },
        saveOrg(){
          this.isloaing = true
          if(this.FormCompanyInfo.action == 'add'){
           window.billing.post(window.urlmaster +'api/organization/' + window.localuserdata ,{
                user_id : window.localuserdata,
                companyname: this.FormCompanyInfo.companyname,
                firstname: this.FormCompanyInfo.firstname,
                lastname: this.FormCompanyInfo.lastname,
                address: this.FormCompanyInfo.address,
                city: this.FormCompanyInfo.city,
                state: this.FormCompanyInfo.state,
                zipcode: this.FormCompanyInfo.zipcode,
                telephone: this.FormCompanyInfo.telephone,
                website: this.FormCompanyInfo.website,
                email: this.FormCompanyInfo.email
           }).then((response) => {
                 this.isloaing = false
                 if(response.data.status){
                     this.NoRecordTaxe = false
                    this.$modal.hide('setting-org')
                    this.getOrganizations()
                     this.$notify({
                    group: 'noti',
                    title: 'ADD',
                    type: 'success',
                    text: 'Add Organization Successful'
                  });

                 }
  
                }).catch((error) => console.log(error,this.isloaing = false));
        }
        }

  }
};
</script>
<style scope>
    .activeorg{
        width: 12px;
        height: 12px;
        background-color: #5ac146;
        position: relative;
        display: block;
        border-radius: 50%;
        float: right;
    }
    .offorg{
        width: 12px;
        height: 12px;
        background-color: #a2a2a2;
        position: relative;
        display: block;
        border-radius: 50%;
        float: right;
    }
</style>


